import React from 'react';
import { formatAmountInWords } from '../../../utils/amountInWords';
import { formatDate, formatCurrency, formatQuantity } from './taxInvoiceUtils';

const TaxInvoicePrintLayout = ({ data }) => {
    if (!data) return null;

    const { items, printDisplay = { showAddress1: true, showAddress2: true, showCountry: true, showPhone: true, showVat: true } } = data;

    return (
        <div id="container">
            <div className="print-content">
                <div className="clearfix"></div>
                <div className="title">
                    <span>TAX INVOICE</span>
                </div>
                <section className="middle-box">
                    <section id="client-info">
                        {data.customerCode ? (
                            <span className="invoice_bill_to_label">{data.customerCode}</span>
                        ) : null}
                        <span className="client-name invoice_client_name">
                            {data.customerName}
                        </span>
                        <div className="client-address">
                            {printDisplay.showAddress1 && data.address1 ? <div>{data.address1}</div> : null}
                            {printDisplay.showAddress2 && data.address2 ? <div>{data.address2}</div> : null}
                            {printDisplay.showCountry && data.country ? <div>{data.country}</div> : null}
                        </div>
                        {(printDisplay.showPhone || printDisplay.showVat) ? (
                        <section id="client-contacts">
                            {printDisplay.showPhone ? (
                            <div>
                                <span className="client_label">PHONE : </span>
                                <span className="client_value">{data.phone}</span>
                            </div>
                            ) : null}
                            {printDisplay.showVat ? (
                            <div>
                                <span className="client_label">VAT NO : </span>
                                <span className="client_value">{data.vatNumber}</span>
                            </div>
                            ) : null}
                        </section>
                        ) : null}
                    </section>

                    <section id="invoice-info">
                        <div>
                            <span className="invoice_label">INVOICE NUMBER : </span>
                            <span className="invoice_value">{data.invoiceNumber || '-'}</span>
                        </div>
                        <div>
                            <span className="invoice_label">INVOICE DATE : </span>
                            <span className="invoice_value">{formatDate(data.invoiceDate)}</span>
                        </div>
                        {data.lpoNumber ? (
                            <div>
                                <span className="invoice_label">LPO NO:</span>
                                <span className="invoice_value">{data.lpoNumber}</span>
                            </div>
                        ) : null}
                        {data.lpoDate ? (
                            <div>
                                <span className="invoice_label">LPO DATE:</span>
                                <span className="invoice_value">{formatDate(data.lpoDate)}</span>
                            </div>
                        ) : null}
                    </section>
                </section>
                <div className="clearfix"></div>
                <section id="items">
                    <table cellSpacing="0" cellPadding="0">
                        <thead>
                            <tr>
                                <th className=""></th>
                                <th className="">ITEM </th>
                                <th className="invoice_item_quantity_label">QTY</th>
                                <th className="invoice_item_unit_label">UNIT</th>
                                <th className="invoice_item_price_label">PRICE</th>
                                <th className="invoice_item_vat_label">AMT. EXCL. VAT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items && items.length > 0 ? (
                                items.map((row, idx) => (
                                    <tr key={idx} data-iterate="item">
                                        <td className="invoice_item_row_number" style={{ position: 'relative' }}>
                                            {idx + 1}
                                        </td>
                                        <td>
                                            <span className="invoice_item_description">
                                                {row.name}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="show-mobile invoice_item_quantity_label" style={{ display: 'inline' }}>QUANTITY</span>
                                            <span className="invoice_item_quantity">{formatQuantity(row.quantity)}</span>
                                        </td>
                                        <td>
                                            <span className="show-mobile invoice_item_unit_label" style={{ display: 'inline' }}>UNIT</span>
                                            <span className="invoice_item_unit">{row.unit}</span>
                                        </td>
                                        <td>
                                            <span className="show-mobile invoice_item_price_label" style={{ display: 'inline' }}>PRICE :</span>
                                            <span className="invoice_item_price">{formatCurrency(row.unitPrice)}</span>
                                        </td>
                                        <td>
                                            <span className="show-mobile invoice_item_vat_label" style={{ display: 'inline' }}>AMT. EXCL. VAT:</span>
                                            <span className="invoice_item_vat">{formatCurrency(row.amountExclVat)}</span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" style={{ border: '1px solid #ddd', padding: '10px', textAlign: 'center' }}>No items available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </section>
                <div className="clearfix"></div>
                <section id="sums">
                    <table cellSpacing="0" cellPadding="0">
                        <tbody>
                            <tr className="amount-total">
                                <td rowSpan={5} className="invoice_amount_in_words">
                                    {formatAmountInWords(data.netTotal)}
                                </td>
                                <td className="invoice_amount_subtotal_label">GROSS TOTAL</td>
                                <td className="invoice_amount_subtotal">{formatCurrency(data.grossTotal)}</td>
                            </tr>
                            <tr className="amount-total">
                                <td className="invoice_amount_subtotal_label">DISCOUNT</td>
                                <td className="invoice_amount_subtotal">{formatCurrency(data.discountAmount)}</td>
                            </tr>
                            <tr className="amount-total">
                                <td className="invoice_amount_subtotal_label">SUB TOTAL</td>
                                <td className="invoice_amount_subtotal">{formatCurrency(data.subTotal)}</td>
                            </tr>
                            <tr className="amount-total">
                                <td className="invoice_amount_subtotal_label">VAT 10%</td>
                                <td className="invoice_amount_subtotal">{formatCurrency(data.vatAmount)}</td>
                            </tr>
                            <tr className="amount-total">
                                <td className="invoice_amount_subtotal_label">NET TOTAL</td>
                                <td className="invoice_amount_subtotal">{formatCurrency(data.netTotal)}</td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <div className="page-indicator" aria-hidden="true" />
            </div>
        </div>
    );
};

export default TaxInvoicePrintLayout;
